import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbIconLibraries } from '@nebular/theme';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Copyright© QUICKTEL® 2025
    </span>
    <div class="socials">
      <nb-actions size="small">
        <nb-action class="control-item" [icon]="{icon: 'facebook-square', pack: 'fab'}" (click)="onClick('facebook')"></nb-action>
        <nb-action class="control-item" [icon]="{icon: 'youtube', pack: 'fab'}" (click)="onClick('youtube')"></nb-action>
        <nb-action class="control-item" [icon]="{icon: 'linkedin', pack: 'fab'}" (click)="onClick('linkedin')"></nb-action>
      </nb-actions>
    </div>
  `,
})
export class FooterComponent  {

  constructor(
    private _router: Router,
    private iconLibraries: NbIconLibraries
  ){
     this.iconLibraries.registerFontPack('fab', { packClass: 'fab', iconClassPrefix: 'fa' });
  }

  onClick(value){
    switch(value){
      case "facebook": window.open('https://www.facebook.com/quicktel.wireless/', '_blank'); break;
      case "youtube": window.open('https://www.youtube.com/@QUICKTEL-Wireless/', '_blank'); break;
      case "linkedin": window.open('https://www.linkedin.com/company/quicktel-wireless/', '_blank'); break;
    }
  }
}
